export default __webpack_public_path__ + "static/media/Background_00292.3b33c0a2.png";